import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { DataTypeFilter } from "./dataTypeFilter";
import { Props } from "./type";
import styles from "./styles.scss";

function Filters({ filter, setFilter, scope = "planzone" }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <p className={styles.title}>{t("calendarPage.filters.title")}</p>
      <div className={styles.row}>
        {scope === "planzone" && (
          <FilterMenu
            filter={filter}
            placeholder={t("calendarPage.filters.zoneDefault")}
            views={[
              "zones",
              "projectPortfolios",
              "projectsTags",
              "projectStatuses",
              "projectsElementsTags",
            ]}
            openedViews={["zones"]}
            setFilter={setFilter}
          />
        )}
        {scope === "zone" && (
          <FilterMenu
            filter={filter}
            placeholder={t("calendarPage.filters.zoneDefault")}
            views={[
              "projects",
              "projectPortfolios",
              "projectsTags",
              "projectStatuses",
              "projectsElementsTags",
            ]}
            openedViews={[]}
            setFilter={setFilter}
          />
        )}
        <FilterMenu
          filter={filter}
          placeholder={t("calendarPage.filters.resourceDefault")}
          views={["resources"]}
          openedViews={["resources"]}
          setFilter={setFilter}
        />
        <DataTypeFilter
          dataTypes={filter.elementTypes}
          select={(elementTypes) => setFilter({ ...filter, elementTypes })}
        />
      </div>
    </div>
  );
}

export { Filters };
